
import React from 'react';
import { Card, Badge, Flex } from 'antd-mobile';
import { formatDate, formatBillUnit } from "../../../utils/utils"

function CompanyDetail(props) {

    const { detailInfo } = props

    return (
        <Card key={detailInfo.CompanyId} style={{marginBottom: '10px'}}>
            <Card.Header
            title={detailInfo.Email || '邮箱不存在'}
            // extra={<span style={{color: '#108ee9'}} onClick={() => handleAction(detailInfo)}>操作</span>}
            />
            <Card.Body style={{paddingBottom: '10px'}}>
              <Flex className='flex'>
                  <Flex.Item className='description-title'>CompanyID</Flex.Item>
                  <Flex.Item className='description-content'>{detailInfo.CompanyId || '-'}</Flex.Item>
              </Flex>
                <Flex className='flex'>
                    <Flex.Item className='description-title'>币种</Flex.Item>
                    <Flex.Item className='description-content'>{detailInfo.Currency.toUpperCase() || '-'}</Flex.Item>
                </Flex>
                <Flex className='flex'>
                    <Flex.Item className='description-title'>注册地</Flex.Item>
                    <Flex.Item className='description-content'>{detailInfo.RegistrationCountry || '-'}</Flex.Item>
                </Flex>
                <Flex className='flex'>
                    <Flex.Item className='description-title'>冻结金额</Flex.Item>
                    <Flex.Item className='description-content'>{(detailInfo.Currency.toUpperCase())} {formatBillUnit(detailInfo.AmountFreeze) || '-'}</Flex.Item>
                </Flex>
                <Flex className='flex'>
                    <Flex.Item className='description-title'>信用额度</Flex.Item>
                    <Flex.Item className='description-content'>{(detailInfo.Currency.toUpperCase())} {formatBillUnit(detailInfo.AmountCredit) || '-'}</Flex.Item>
                </Flex>
                <Flex className='flex'>
                    <Flex.Item className='description-title'>赠金</Flex.Item>
                    <Flex.Item className='description-content'>{(detailInfo.Currency.toUpperCase())} {formatBillUnit(detailInfo.AmountFree) || '-'}</Flex.Item>
                </Flex>
                <Flex className='flex'>
                    <Flex.Item className='description-title'>现金余额</Flex.Item>
                    <Flex.Item className='description-content'>{(detailInfo.Currency.toUpperCase())} {formatBillUnit(detailInfo.Amount) || '-'}</Flex.Item>
                </Flex>
                <Flex className='flex'>
                    <Flex.Item className='description-title'>账户可用余额</Flex.Item>
                    <Flex.Item className='description-content'>{(detailInfo.Currency.toUpperCase())} {formatBillUnit(detailInfo.AmountAvailable) || '-'}</Flex.Item>
                </Flex>
            </Card.Body>
            <Card.Footer 
                content={
                    detailInfo.Upgrade === 1 ? 
                    <Badge text={"已升级"} style={{backgroundColor: '#21b68a'}} /> : 
                    <Badge text={"未升级"} hot />}
                extra={<div>{`${formatDate(detailInfo.RegistrationTime) || '-'}`}</div>} 
            />
        </Card>
    )
}

export default CompanyDetail